export default __webpack_public_path__ + "static/donate-clouds-79a1823239042e17aacf3bcbfa34c5ed.jpg";